import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const commentApi = createApi({
  reducerPath: "commentApi",
  baseQuery: customFetchBase({ url: "comment" }),
  tagTypes: ["Comment"],
  endpoints: (builder) => ({
    getComments: builder.query({
      query: ({
        targetId,
        targetType,
        page = 1,
        limit = 20,
        sort = "createdAt",
        order = "desc",
      }) => ({
        url: `/${targetId}`,
        method: "GET",
        params: {
          targetType,
          page,
          limit,
          sort,
          order,
        },
      }),
      providesTags: (result, error, arg) => [
        { type: "Comment", id: `${arg.targetType}-${arg.targetId}` },
      ],
    }),

    // ثبت کامنت یا پاسخ
    addComment: builder.mutation({
      query: ({ targetType, targetId, text, parentId = null }) => ({
        url: "/",
        method: "POST",
        body: {
          targetType,
          targetId,
          text,
          parentId,
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Comment", id: `${arg.targetType}-${arg.targetId}` },
      ],
    }),
  }),
});

export const { useGetCommentsQuery, useAddCommentMutation } = commentApi;
